import { Dispatch } from 'redux';
import AttributeController from '../controllers/AttributeController';
import attributeHandler from '../errorHandlers/attribute-handler';
import commonHandler from '../errorHandlers/common-handler';
import { ContactVariable } from '../interfaces/contacts';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class AttributeCRUDActions extends CrudActionContainer {
  addAttributeAction: string;
  deleteAttributeValueAction: string;
  retriveBusinessAttributesAction: string;

  constructor() {
    super('ATTRIBUTE');
    this.addAttributeAction = super.makeActionKey('ADD_ATTRIBUTE');
    this.deleteAttributeValueAction = super.makeActionKey(
      'DELETE_ATTRIBUTE_VALUE',
    );
    this.retriveBusinessAttributesAction = super.makeActionKey(
      'RETRIEVE_BUSINESS_ATTRIBUTES',
    );
  }

  create(
    facebookPageId: number,
    entity: { name: string },
    returnFullEntity?: boolean,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));
      try {
        const response = await AttributeController.postAttribute(
          facebookPageId,
          entity,
        );
        await dispatch(this.retrieveAll(facebookPageId));
        return returnFullEntity ? response.variable : response.variable.id;
      } catch (e) {
        attributeHandler(dispatch)(e);
      }
    };
  }

  retrieveAll(pageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));
      try {
        const response = await AttributeController.getAll(pageId);
        dispatch(this.retrievedAll(response.filter(a => !a.webhooksOnly)));
      } catch (e) {
        attributeHandler(dispatch)(e);
      }
    };
  }

  retrieveBusinessAttributes(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retriveBusinessAttributesAction));
      try {
        const response = await AttributeController.retrieveBusinessAttributes(
          facebookPageId,
        );
        dispatch({
          type: this.retriveBusinessAttributesAction,
          payload: response,
        });
        return response;
      } catch (e) {
        attributeHandler(dispatch)(e);
      }
    };
  }

  delete(facebookPageId: number | undefined, attributeId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        const response = await AttributeController.deleteAttribute(attributeId);
        if (facebookPageId) {
          dispatch(this.retrieveAll(facebookPageId));
        }
        return response;
      } catch (e) {
        attributeHandler(dispatch)(e, this.deleteAction);
      }
    };
  }

  addAttribute(
    contactId: number,
    attributeName: string,
    attributeValue: string,
  ) {
    return async (dispatch: Dispatch<StoreState>): Promise<ContactVariable> => {
      dispatch(this.busy(this.addAttributeAction));
      try {
        const response: ContactVariable =
          await AttributeController.addAttribute(
            contactId,
            attributeName,
            attributeValue,
          );
        dispatch(this.unbusy());
        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }

  deleteAttributeValue(attributeId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.deleteAttributeValueAction));
      try {
        const response: ContactVariable =
          await AttributeController.deleteVariableValue(attributeId);
        dispatch(this.unbusy());
        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }
}

const attributeCRUDActions = new AttributeCRUDActions();

export default attributeCRUDActions;

export const useAttributeCRUDActions = getActionHookBuilder(
  attributeCRUDActions,
  [
    'addAttribute',
    'create',
    'delete',
    'deleteAttributeValue',
    'retrieveAll',
    'retrieveBusinessAttributes',
  ],
);
